export enum EquipmentMethod {
  SIMPLE = 'SIMPLE',
  DETAILED = 'DETAILED',
  AUTOMATIC = 'AUTOMATIC',
}
